/**
 * Brand values, read from Vite env at build time. The code is brand-neutral;
 * the brand pack sets VITE_BRAND_* in .env per deployment. Fallbacks are neutral
 * placeholders, never a specific brand.
 */
export const BRAND = {
  name: import.meta.env.VITE_BRAND_NAME ?? 'Fitness',
  wordmarkLead: import.meta.env.VITE_BRAND_WORDMARK_LEAD ?? 'FIT',
  wordmarkTail: import.meta.env.VITE_BRAND_WORDMARK_TAIL ?? 'PLATFORM',
  webHost: import.meta.env.VITE_BRAND_WEB_HOST ?? 'www.example.com',
  rootDomain: import.meta.env.VITE_BRAND_ROOT_DOMAIN ?? 'example.com',
} as const;
